import React, { Component } from 'react';
import Link from '../Link';
import PropTypes from 'prop-types';
// Style
import {
    Row,
    Col,
} from 'react-bootstrap';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { FormattedMessage, injectIntl } from 'react-intl';
import s from './Dashboard.css';
import bt from '../../components/commonStyle.css';

// Locale
import messages from '../../locale/messages';

import RightSideIcon from "/public/SiteIcons/right-arrow-icon.svg";
import settingIcon from "/public/SiteIcons/system-upgrade.svg";

class BookingInformation extends React.Component {

    static propTypes = {
        dashboardCount: PropTypes.shape({
            checkinToday: PropTypes.number,
            checkoutToday: PropTypes.number,
            currentStays: PropTypes.number,
            pendingRequests: PropTypes.number,
            allUnreadMessages: PropTypes.number,
            allMessages: PropTypes.number,
            reviews: PropTypes.number
        })
    };

    static defaultProps = {
        dashboardCount: {
            checkinToday: 0,
            checkoutToday: 0,
            currentStays: 0,
            pendingRequests: 0,
            allUnreadMessages: 0,
            allMessages: 0,
            reviews: 0
        }
    };

    render() {
        const { dashboardCount } = this.props;
        const {
            checkinToday = 0,
            checkoutToday = 0,
            currentStays = 0,
            pendingRequests = 0,
            allUnreadMessages = 0,
            allMessages = 0,
            reviews = 0
        } = dashboardCount || {};

        return (
            <div className={bt.space2}>
                <Row>
                    <Col xs={12} sm={6} md={6} lg={6}>
                        <div className={cx(s.dashBoardSideMenuBox, bt.space3, 'bgBlack')}>
                            <span className={cx(s.dashboardMenuIconsTexts, 'textWhite')}>
                                <span className={cx(s.minimumWidth130)}>
                                    <FormattedMessage {...messages.checkInsToday} />
                                </span>
                                <span className={cx(s.pullRight, 'floatLeft')}>
                                    <img src={RightSideIcon} className={'rightArrowItineraryRTL'} />
                                    {' '}
                                </span>
                                <span className={cx(s.countTextColor)}>
                                    {' '}{checkinToday}
                                </span>
                            </span>
                        </div>
                    </Col>

                    <Col xs={12} sm={6} md={6} lg={6}>
                        <div className={cx(s.dashBoardSideMenuBox, bt.space3, 'bgBlack')}>
                            <span className={cx(s.dashboardMenuIconsTexts, 'textWhite')}>
                                <span className={cx(s.minimumWidth130)}>
                                    <FormattedMessage {...messages.checkOutsToday} />
                                </span>
                                <span className={cx(s.pullRight, 'floatLeft')}>
                                    <img src={RightSideIcon} className={'rightArrowItineraryRTL'} />
                                    {' '}
                                </span>
                             <span className={cx(s.countTextColor)}>
                                    {' '}{checkoutToday}
                                </span>
                            </span>
                        </div>
                    </Col>

                    <Col xs={12} sm={6} md={6} lg={6}>
                        <div className={cx(s.dashBoardSideMenuBox, bt.space3, 'bgBlack')}>
                            <span className={cx(s.dashboardMenuIconsTexts, 'textWhite')}>
                                <span className={cx(s.minimumWidth130)}>
                                    <FormattedMessage {...messages.currentStays} />
                                </span>
                                <span className={cx(s.pullRight, 'floatLeft')}>
                                    <img src={RightSideIcon} className={'rightArrowItineraryRTL'} />
                                    {' '}
                                </span>
                                <span className={cx(s.countTextColor)}>
                                    {' '}{currentStays}
                                </span>
                            </span>
                        </div>
                    </Col>

                    <Col xs={12} sm={6} md={6} lg={6}>
                        <Link to={'/inbox?hosting'} className={s.noTextDecoration}> 
                            <div className={cx(s.dashBoardSideMenuBox, bt.space3, 'bgBlack')}>
                                <span className={cx(s.dashboardMenuIconsTexts, 'textWhite')}>
                                    <span className={cx(s.minimumWidth130)}>
                                        <FormattedMessage {...messages.pendingRequests} />
                                    </span>
                                    <span className={cx(s.pullRight, 'floatLeft')}>
                                        <img src={RightSideIcon} className={'rightArrowItineraryRTL'} />
                                        {' '}
                                    </span>
                                        <span className={cx(s.countTextColor)}>
                                        {' '}{pendingRequests}
                                    </span>
                                </span>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={12} sm={6} md={6} lg={6}>
                        <Link to={'/inbox'} className={s.noTextDecoration}>
                            <div className={cx(s.dashBoardSideMenuBox, bt.space3, 'bgBlack')}>
                                <span className={cx(s.dashboardMenuIconsTexts, 'textWhite')}>
                                    <span className={cx(s.minimumWidth130)}>
                                        <FormattedMessage {...messages.unreadMessages} />
                                        {' '}
                                    </span>
                                    <span className={cx(s.pullRight, 'floatLeft')}>
                                        <img src={RightSideIcon} className={'rightArrowItineraryRTL'} />
                                        {' '}
                                    </span>
                                 <span className={cx(s.countTextColor)}>
                                        {' '}{allUnreadMessages}
                                    </span>
                                </span>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={12} sm={6} md={6} lg={6}>
                        <Link to={'/inbox'} className={s.noTextDecoration}>
                            <div className={cx(s.dashBoardSideMenuBox, bt.space3, 'bgBlack')}>
                                <span className={cx(s.dashboardMenuIconsTexts, 'textWhite')}>
                                    <span className={cx(s.minimumWidth130)}>
                                        <FormattedMessage {...messages.allMessages} />
                                    </span>
                                    <span className={cx(s.pullRight, 'floatLeft')}>
                                        <img src={RightSideIcon} className={'rightArrowItineraryRTL'} />
                                        {' '}
                                    </span>
                                    <span className={cx(s.countTextColor)}>
                                        {' '}{allMessages}
                                    </span>
                                </span>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={12} sm={6} md={6} lg={6}>
                        <Link to={'/user/reviews/about-you'} className={s.noTextDecoration}>
                            <div className={cx(s.dashBoardSideMenuBox, bt.space3, 'bgBlack')}>
                                <span className={cx(s.dashboardMenuIconsTexts, 'textWhite')}>
                                    <span className={cx(s.minimumWidth130)}>
                                        <FormattedMessage {...messages.reviews} />
                                    </span>
                                    <span className={cx(s.pullRight, 'floatLeft')}>
                                        <img src={RightSideIcon} className={'rightArrowItineraryRTL'} />
                                        {' '}
                                    </span>
                                 <span className={cx(s.countTextColor)}>
                                        {' '}{reviews}
                                    </span>
                                </span>
                            </div>
                        </Link>
                    </Col>

                    <Col xs={12} sm={6} md={6} lg={6}>
                        <Link to={'/user/edit'} className={s.noTextDecoration}>
                            <div className={cx(s.dashBoardSideMenuBox, bt.space3, 'bgBlack')}>
                                <span className={cx(s.dashboardMenuIconsTexts, 'textWhite')}>
                                    <span className={cx(s.minimumWidth130)}>
                                        <FormattedMessage {...messages.updateProfile} />
                                    </span>
                                    <span className={cx(s.pullRight, 'floatLeft')}>
                                        <img src={RightSideIcon} className={'rightArrowItineraryRTL'} />
                                        {' '}
                                    </span>
                                    <span>
                                        <img src={settingIcon} alt="Setting Icon" className={cx(s.height18)}/>
                                    </span>
                                </span>
                            </div>
                        </Link>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default injectIntl(withStyles(s, bt)(BookingInformation));